import { render, staticRenderFns } from "./TermsModal.vue?vue&type=template&id=c0ae8d06&"
import script from "./TermsModal.vue?vue&type=script&lang=js&"
export * from "./TermsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports